import { compose } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import * as savedTimelineDashboardActions from '@store/timeline/dashboard/actions';
import { initTempDashboard } from '@store/timeline/tempDashboard/actions';
import {
  dashboardResponseSelector,
  dashboardIsFetchingSelector,
} from '@store/timeline/dashboard/selectors';
import { DASHBOARD_TYPE, PAGE_TYPE } from '@utils/constants';
import tempDashboardSelector, {
  tempDashboardDataSelector,
} from '@store/timeline/tempDashboard/selectors';
import * as tempDashboardActions from '@store/tempDashboard/actions';
import injectorServer from '../common/injectorServer';
import dashboard from '../common/dashboard';
import Timeline from './index';

const selectors = createSelector(
  dashboardResponseSelector,
  dashboardIsFetchingSelector,
  tempDashboardDataSelector,
  tempDashboardSelector,
  (response, isFetching, dashboardState, tempDashboard) => ({
    response,
    isFetching,
    dashboardType: DASHBOARD_TYPE.TIMELINE,
    dashboard: dashboardState,
    tempIsFetching: tempDashboard.isFetching,
  }),
);

const SavedTimeline = compose(
  connect(selectors, {
    initTempDashboard,
    initDashboard: savedTimelineDashboardActions.initRequest,
    getDashboard: savedTimelineDashboardActions.getDashboard,
    fetchingAction: savedTimelineDashboardActions.fetching,
  }),
  dashboard(),
)(Timeline);

export default injectorServer(
  {
    initiators: [tempDashboardActions.init],
  },
  {
    pageType: PAGE_TYPE.SAVED_DASHBOARD,
  },
)(SavedTimeline);
